// extracted by mini-css-extract-plugin
module.exports = {"howUsesNeat":"BoxedInfo_howUsesNeat__nADVr","blockContainer":"BoxedInfo_blockContainer__9dDTG","neatUserBlock":"BoxedInfo_neatUserBlock__gkGqo"};